// 礼物计算器数据库
export default [
    { id: 1, name: '嘉年华', price: 30000 },
    { id: 2, name: '梦幻城堡', price: 28888 },
    { id: 3, name: '荣耀之巅', price: 28888 },
    { id: 4, name: '浪漫马车', price: 28888 },
    { id: 5, name: '抖音飞艇', price: 20000 },
    { id: 6, name: '宇宙之心', price: 18888 },
    { id: 7, name: '一路有你', price: 17888 },
    { id: 8, name: '云中秘境', price: 13140 },
    { id: 9, name: '抖音一号', price: 10001 },
    { id: 10, name: '为爱启航', price: 10001 },
    { id: 11, name: '情定三生', price: 9666 },
    { id: 12, name: '大圣降临', price: 8999 },
    { id: 13, name: '真爱永恒', price: 8999 },
    { id: 14, name: '摩天大厦', price: 8999 },
    { id: 15, name: '乘风破浪', price: 8000 },
    { id: 16, name: '云霄大厦', price: 7888 },
    { id: 17, name: '星际玫瑰', price: 7500 },
    { id: 18, name: '月下瀑布', price: 6666 },
    { id: 19, name: '天空之境', price: 6399 },
    { id: 20, name: '豪华游轮', price: 6000 },
    { id: 21, name: '心动丘比特', price: 5000 },
    { id: 22, name: '海上升明月', price: 4166 },
    { id: 23, name: '暗夜之翼', price: 3888 },
    { id: 24, name: '奏响人生', price: 3666 },
    { id: 25, name: '私人飞机', price: 3000 },
    { id: 26, name: '环游世界', price: 3000 },
    { id: 27, name: '冰冻战车', price: 3000 },
    { id: 28, name: '直升飞机', price: 2999 },
    { id: 29, name: '浪漫约会', price: 2999 },
    { id: 30, name: '星光许愿树', price: 2999 },
    { id: 31, name: '天使之翼', price: 2888 },
    { id: 32, name: '花海泛舟', price: 2800 },
    { id: 33, name: '奇幻八音盒', price: 2399 },
    { id: 34, name: '夏日干杯', price: 2299 },
    { id: 35, name: '热恋惊喜', price: 2099 },
    { id: 36, name: '伴你永相随', price: 2000 },
    { id: 37, name: '梦幻穿越', price: 2000 },
    { id: 38, name: '浪漫恋人', price: 1999 },
    { id: 39, name: '光之祝福', price: 1999 },
    { id: 40, name: '爱意花海', price: 1999 },
    { id: 41, name: '冲锋战马', price: 1999 },
    { id: 42, name: '爱的华尔兹', price: 1999 },
    { id: 43, name: '定海神针', price: 1999 },
    { id: 44, name: '记录甜蜜', price: 1999 },
    { id: 45, name: '夏天的夜晚', price: 1999 },
    { id: 46, name: '薰衣草庄园', price: 1899 },
    { id: 47, name: '炫彩射击', price: 1888 },
    { id: 48, name: '棋幻玫瑰', price: 1888 },
    { id: 49, name: '樱花之恋', price: 1800 },
    { id: 50, name: '浪漫营地', price: 1699 },
    { id: 51, name: '大圣抢亲', price: 1699 },
    { id: 52, name: '心动信号', price: 1599 },
    { id: 53, name: '花落长亭', price: 1588 },
    { id: 54, name: '萤火虫之花', price: 1588 },
    { id: 55, name: '钟意你', price: 1520 },
    { id: 56, name: '追星逐梦', price: 1500 },
    { id: 57, name: '恋恋青春', price: 1200 },
    { id: 58, name: '萌喵之恋', price: 1200 },
    { id: 59, name: '跑车', price: 1200 },
    { id: 60, name: '冲刺狂欢', price: 1200 },
    { id: 61, name: '勇往直前', price: 1200 },
    { id: 62, name: '爱情鸟', price: 1009 },
    { id: 63, name: '为你加冕', price: 1000 },
    { id: 64, name: '蜜蜂叮叮', price: 1000 },
    { id: 65, name: '屋顶的等待', price: 999 },
    { id: 66, name: '为你弹唱', price: 999 },
    { id: 67, name: '星夜华服', price: 999 },
    { id: 68, name: '冰晶天鹅', price: 999 },
    { id: 69, name: '芳香四溢', price: 999 },
    { id: 70, name: '天鹅湖', price: 999 },
    { id: 71, name: '霓虹机车', price: 999 },
    { id: 72, name: '红色高跟', price: 999 },
    { id: 73, name: '秋别雪舞', price: 999 },
    { id: 74, name: '奇妙纸箱', price: 999 },
    { id: 75, name: '春意盎然', price: 999 },
    { id: 76, name: '心动能量站', price: 999 },
    { id: 77, name: '纸短情长', price: 921 },
    { id: 78, name: '璀璨舞台', price: 899 },
    { id: 79, name: '梦幻蝶翼', price: 899 },
    { id: 80, name: '金箍打call', price: 899 },
    { id: 81, name: '为你喝彩', price: 899 },
    { id: 82, name: '掌上明珠', price: 888 },
    { id: 83, name: '甜蜜蜜', price: 888 },
    { id: 84, name: '海螺之心', price: 799 },
    { id: 85, name: '日出相伴', price: 726 },
    { id: 86, name: '万象烟花', price: 688 },
    { id: 87, name: '深情燃羽', price: 688 },
    { id: 88, name: 'PK宝箱', price: 600 },
    { id: 89, name: '灵龙现世', price: 600 },
    { id: 90, name: '热血出击', price: 599 },
    { id: 91, name: '浪漫花火', price: 599 },
    { id: 92, name: '爱情树下', price: 599 },
    { id: 93, name: '娶你回家', price: 599 },
    { id: 94, name: '梦幻舞动', price: 599 },
    { id: 95, name: '烛光晚餐', price: 599 },
    { id: 96, name: '和春天合影', price: 599 },
    { id: 97, name: '陪伴着你', price: 599 },
    { id: 98, name: '冰冻玫瑰', price: 599 },
    { id: 99, name: '恋爱立体书', price: 599 },
    { id: 100, name: '猫球贴贴', price: 599 },
    { id: 101, name: '时光倒流', price: 599 },
    { id: 102, name: '爱意降临', price: 599 },
    { id: 103, name: '唱响舞台', price: 599 },
    { id: 104, name: '一鹿爱你', price: 599 },
    { id: 105, name: '鲜花速递', price: 599 },
    { id: 106, name: '星语沙漏', price: 599 },
    { id: 107, name: '今日份松弛', price: 599 },
    { id: 108, name: '橙风破浪', price: 599 },
    { id: 109, name: '树下摇曳', price: 599 },
    { id: 110, name: '形影相伴', price: 599 },
    { id: 111, name: '冰旋雅韵', price: 599 },
    { id: 112, name: '吃泡面', price: 599 },
    { id: 113, name: '霓裳余音', price: 599 },
    { id: 114, name: '洗个澡', price: 599 },
    { id: 115, name: '兔兔扭蛋机', price: 599 },
    { id: 116, name: '神机妙蒜', price: 599 },
    { id: 117, name: '心动初恋', price: 599 }
];